import React, { useState } from "react"

import { Form, Field } from "formik"
import ReCAPTCHA from "react-google-recaptcha"
import { Input, Select, Radio } from "components/anti/forms/forms"
import { Button } from "components/anti/buttons/buttons"
import { useScrollAnim } from "src/components/hooks/hooks"

export const FormBox = ({
  handleSubmit,
  handleChange,
  errors,
  touched,
  values,
  isSubmitting,
  handleRadio,
  successSubmit,
  lang,
}) => {
  const [trigger, anim] = useScrollAnim()

  const [radioSelect, setRadioSelect] = useState("Mr")

  const changeRadio = value => {
    setRadioSelect(value)
  }

  return (
    <Form onSubmit={handleSubmit} ref={trigger}>
      <div className="form-row row-5">
        <p
          className={`container px-5 font-weight-light text-gray-600 ${anim(
            1
          )}`}
        >
          {lang === "en" ? "Salutations" : "Titel"}
        </p>
        <div className="form-group col-md-12 d-flex">
          <Radio
            label={lang === "en" ? "Mr" : "Tuan"}
            isChecked={radioSelect === "Mr"}
            id="salutations"
            name="salutations"
            value="Mr"
            labelClassName="text-gray-600 font-weight-light"
            className={`d-flex align-items-center ml-2 mr-0 ${anim(2)}`}
            handleChangeFilter={handleRadio}
            onChange={() => changeRadio("Mr")}
          />
          <Radio
            label={lang === "en" ? "Ms" : "Nona"}
            isChecked={radioSelect === "Ms"}
            id="salutations"
            name="salutations"
            value="Ms"
            labelClassName="text-gray-600 font-weight-light"
            className={`d-flex align-items-center ml-2 mr-0 ${anim(3)}`}
            handleChangeFilter={handleRadio}
            onChange={() => changeRadio("Ms")}
          />
          <Radio
            label={lang === "en" ? "Mrs" : "Nyonya"}
            isChecked={radioSelect === "Mrs"}
            id="salutations"
            name="salutations"
            value="Mrs"
            labelClassName="text-gray-600 font-weight-light"
            className={`d-flex align-items-center ml-2 mr-0 ${anim(4)}`}
            handleChangeFilter={handleRadio}
            onChange={() => changeRadio("Mrs")}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "First Name" : "Nama Depan"}
            // inputClassName={inputClassName}
            as="input"
            id="firstName"
            name="firstName"
            className={`${anim(5)}`}
            value={values["firstName"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Last Name" : "Nama Belakang"}
            // inputClassName={inputClassName}
            as="input"
            id="lastName"
            name="lastName"
            className={`${anim(6)}`}
            value={values["lastName"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Company Name" : "Nama Perusahaan"}
            // inputClassName={inputClassName}
            as="input"
            id="companyName"
            name="companyName"
            className={`${anim(7)}`}
            value={values["companyName"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Phone Number" : "Nomor Telepon"}
            // inputClassName={inputClassName}
            as="input"
            id="phoneNumber"
            name="phoneNumber"
            className={`${anim(8)}`}
            value={values["phoneNumber"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={"Email"}
            // inputClassName={inputClassName}
            type="email"
            as="input"
            id="email"
            name="email"
            className={`${anim(9)}`}
            value={values["email"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Address (optional)" : "Alamat (opsional)"}
            // inputClassName={inputClassName}
            as="input"
            id="address"
            name="address"
            className={`${anim(10)}`}
            value={values["address"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "City (optional)" : "Kota (opsional)"}
            // inputClassName={inputClassName}
            as="input"
            id="city"
            name="city"
            className={`${anim(11)}`}
            value={values["city"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-md-6">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Country (optional)" : "Negara (opsional)"}
            // inputClassName={inputClassName}
            as="input"
            id="country"
            name="country"
            className={`${anim(12)}`}
            value={values["country"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-12">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Subject" : "Subjek"}
            // inputClassName={inputClassName}
            as="input"
            id="subject"
            name="subject"
            className={`${anim(13)}`}
            value={values["subject"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-12">
          <Input
            formik
            floatingLabel
            variant={"underline"}
            label={lang === "en" ? "Message" : "Pesan"}
            // inputClassName={inputClassName}
            as="textarea"
            rows={4}
            id="message"
            name="message"
            className={`${anim(14)}`}
            value={values["message"]}
            onChange={handleChange}
            errors={errors}
            touched={touched}
          />
        </div>
        <div className="form-group col-12">
          <Field name="recaptcha">
            {({ field, form }) => (
              <ReCAPTCHA
                // sitekey="6LdnDMQaAAAAAFAHGkh2SwJ0dtJ8v5jSc8sW6VCq"
                sitekey="6LcxQiAaAAAAAFHwnYJcVv1g5MJPMyIEyUSt4H0R"
                //sitekey={process.env.GATSBY_CAPTHA_KEY}
                onChange={value => {
                  form.setFieldValue("recaptcha", value)
                }}
              />
            )}
          </Field>
          {touched.recaptcha && errors.recaptcha && (
            <div className="invalid-feedback">{errors.recaptcha}</div>
          )}
        </div>
        <div className="col-12">
          <Button
            variant={successSubmit ? "success" : `primary`}
            className={`btn-block ${anim(15)}`}
            disabled={isSubmitting || successSubmit}
          >
            {successSubmit ? (
              <i className="ais ai-check-circle" />
            ) : isSubmitting ? (
              <i className="ais ai-spinner-third fas fa-spin" />
            ) : lang === "en" ? (
              "SUBMIT"
            ) : (
              "KIRIM"
            )}
          </Button>
        </div>
      </div>
    </Form>
  )
}
